export * from "./useI18next";
export { useTranslation } from "react-i18next";
//# sourceMappingURL=index.js.map